import React, { ReactNode, useState } from 'react'

import { Dialog } from 'components/Dialog'

import { AlertDialogButtons } from './components/AlertDialogButtons'
import { AlertDialogProps } from './types'

interface Props extends AlertDialogProps {
  children?: string | ReactNode
}

export const AlertDialog = ({
  acceptButtonLabel,
  onAccept,
  acceptButtonClassName,
  variant = 'default',
  children,
  ...rest
}: Props) => {
  const [isOpen, setIsOpen] = useState(true)

  return (
    <Dialog
      {...rest}
      isOpen={isOpen}
      variant={variant}
      Footer={
        <AlertDialogButtons
          variant={variant}
          acceptButtonLabel={acceptButtonLabel}
          acceptButtonClassName={acceptButtonClassName}
          onAccept={async () => {
            await onAccept?.()
            setIsOpen(false)
          }}
        />
      }
    >
      {children}
    </Dialog>
  )
}
